import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW';
export default {
  message: '系統登錄',
  welecome: '歡迎',
  layer: {
    toggle: '您確定要切換語言版本嗎?',
    tips: '語言切換',
    welcome: '歡迎使用！',
  },
  //全局按鈕文字
  button: {
    humilis:'保存成功',
    search: '搜尋',
    Reset: '清空',
    New: '新增',
    New1: '新增',
    NewMer: '新增',
    NewDevice: '新增',
    NewAgent: '新增',
    NewSalesman: '新增',
    Modify: '修改',
    OK: '確定',
    Cancel: '取消',
    Shops: '店鋪',
    Shops1: '店鋪',
    Shops2: '店鋪列表',
    Merchant: '商戶',
    Enabled: '啟用',
    Enabled1: '啟用',
    Enabled2: '啟用',
    Suspended: '停用',
    Suspended1: '停用',
    Suspended2: '停用',
    Suspended3: '停用',
    Approval: '審批',
    Approve: '核准',
    Approve1: '核准',
    Reject: '拒絕',
    Reject1: '拒絕',
    EnterDetail: '進入詳情',
    Return: '返回',
    RefreshStatus: '更新',
    SaveResult: '蓄存結果',
    delete: '刪除',
    Resubmit: '重新提交',
    Manage: '管理',
    Refresh: '更新',
    Close: '關閉',
    // V2.7新增字段
    view: '查看大圖',
    // V2.8新增字段
    loading: '載入中',
    sending: '發送中',
    colon: '：',
    save: '保存',
    saveTime: '保存時間',
    saveMer: '已保存商戶',
    cancelMer:'未保存商戶',
    edit: '編輯',
  },
  search: {
    //交易流水
    RefNo: '系統單號',
    RefNo1: '系統單號',
    SubAccountNo: '子商戶號',
    // 2.5新增字段
    WechatRMBWallet: '微信支付',
    WechatMOPWallet: '微信支付 MO',
    WechatHKDWallet: '微信支付 HK',
    WeChatPayCatering: ' 微信支付（餐飲）', // 2.16新增
    AlipayHK: '支付寶 HK', // 2.6新增
    Alipay: '支付寶', // 2.6新增
    Conditions:'暫無結果，請重置條件查找',
    SubAccountNo3: '支付寶HK商戶號',
    SubAccountNo4: '支付寶商戶號',
    ServiceChargeRate2: '支付寶HK手续费率（%）',
    ServiceChargeRate3: '支付寶手续费率（%）',
    channelInfo: '通道資料',
    channelInfo1: '通道資料',
    SubAccountNo2: '微信支付商戶號',
    HKSubAccountNo: '微信支付 HK 商戶號',
    WalletType: '錢包類別', // 2.6废弃
    RMBWallet: '人民幣錢包', // 2.6废弃
    HKDWallet: '港幣錢包', // 2.6废弃
    RMBOrHKD: '人民幣錢包商戶號或港幣錢包商戶號',
    Channel: '通道',
    PursePain: '前寶通機構',
    wherewithal:'Allinpay機構',
    // 2.6新增
    CrossBorderWallet: '跨境錢包',
    HongKongWallet: '香港錢包',
    SweepPay: '刷卡支付',
    ScanPay: '掃碼支付',
    Review:'微信審核狀態',
    wereNot:"未審核",
    associates:"審核通過",
    Audit:"審核中",
    partnership:"審核駁回",
    // V2.14新增
    SweepPay1: '付款碼支付',

    SubAccountNo1: '子商戶號',
    AgentName: '所屬代理商',
    AgentName2: '所屬代理商',
    MerchantName: '商戶名稱',
    MerchantName1: '商戶名稱',
    MerchantName2: '商戶名稱',
    TransactionCompleted: '交易结果',
    TransactionCompleted1: '交易结果',
    TransactionCompleted2: '交易结果',
    Select:'選擇通道',
    YES: '是',
    NO: '否',
    Yes: '成功',
    No: ' 失敗',
    refunding: '處理中',
    remarks:'用戶備註',
    Institutional:'機構模式',
    TransactionType: '交易類型',
    TransactionType1: '交易類型',
    WeChatPaySweep: '微信刷卡支付',
    WeChatPayScan: '微信掃碼支付',
    OAPayment: '公眾號支付',
    SelectBeginTime: '交易時間',
    SelectBeginTime1: '订单时间',
    SelectEndTime: '',
    TransactionStatus: '結算狀態',
    TransactionStatus1: '結算狀態',
    SettledDone: '已結算',
    NotSettled: '未結算',
    //商户
    AgentName1: '代理商名稱',
    // AgentName2:'代理商名稱',
    AccountStatus: '商戶狀態',
    Pending: '待批核',
    Rejected: '拒絕批核',
    EstablishmentDate: '入網時間',
    //代理商
    levelID: '代理商編號',
    levelID1: '代理商編號',
    UpperLevel: '上級代理名稱',
    UpperLevel1: '上級代理名稱',
    UpperLevel2: '上級代理',
    Status: '代理商狀態',
    Status1: '代理商狀態',
    Status2: '帳戶狀態',

    // V2.13新增
    websitePayment: '網頁支付',
    PC2Mobile: '網頁支付',
    WAPPayment: 'WAP 支付',
    APPPayment: 'APP 支付',
    bankCardPayment: '銀行卡支付',

     // v2.21新增相关海关字段
     Undeclared:'未申報',
     DeclarationSubmit:'申報已提交',
     Reporting:'申報中',
     DeclarationSuccess:'申報成功',
     DeclarationFail:'申報失敗',
     ApiError:'海關接口異常'
  },
  placeH: {
    All: '所有',
    Please: '請選擇',
    Required: '(必填)',
  },
  hint: {
    supplement:'請補充商戶通道號',
    ThePictureSizeMustNotExceed5M: '上次圖片大小不能超過 5MB',
    MandatoryFieldsAreNotFilledIn: '必填項未填寫',
    usernameDoesNotExist: '用戶不存在',
    pwdErr: '密碼錯誤，請重新登入',
    loading: '請稍後再試',
    pleaseRelogin: '閒置時間過長，請重新登入',
    BuildFailed: '生成失敗',
    NoData: '無數據',
    Alert: '提示',
    Success: '成功',
    Success1: '成功',
    Fail: '失敗',
    Fail1: '失敗',
    SureTo: '确定',
    SuccessfullyModified: '修改成功',
    FailToEdit: '修改失敗',
    ThisAgent: '該代理商嗎?',
    TheAdditonOf: '該店鋪的進件申請嗎?',
    TheAdditonOf1: '確定核準該商户的信息修改嗎?',
    TheAdditonOf3: '確定拒絕該商户的信息修改嗎?',

    TheAdditonOf4: '確定核準該商户的進件申請嗎?',
    TheAdditonOf5: '確定拒絕該商户的進件申請嗎?',

    TheAdditonOf6: "確定核準該店鋪的信息修改嗎?",
    TheAdditonOf7: "確定拒絕該店鋪的信息修改嗎?",
    TheAdditonOf8: "確定核準該店鋪的進件申請嗎?",
    TheAdditonOf9: "確定拒絕該店鋪的進件申請嗎?",

    TheAdditonOf2: '該代理商的進件申請嗎?',
    TheShopInfoChange: '該店鋪的信息修改嗎?', //店铺信息修改
    TheMerchantInfoChange: '該商戶的信息修改嗎?',
    TheAgentInfoChange: '該代理商的信息修改嗎?',
    Approved: '審批成功',
    Rejected: '審批失敗',
    OperationSuccess: '操作成功',
    OperationFail: '操作失敗',
    CreateOK: '提交成功',
    CreateFailed: '提交失敗',
    ChangeOK: '修改成功',
    ChangeFailed: '修改失敗',

    PleaseEnterName: '請輸入姓名',
    PleaseEnterBDStaffNumber: '請輸入業務員編號',
    PleaseEnterIDNumber: '請輸入身份證號碼',
    PleaseEnterPhoneNumber: '請輸入聯絡電話',
    PleaseEnterEmail: '請輸入電郵',
    BDStaffNumberIsValid: '業務員編號驗證通過',
    BDStaffNumberExistsPleaseReEnter: '業務員編號已存在，請重新輸入',
    BDRecordCreated: '新增業務員成功',
    BDCreateFailed: '新增業務員失敗',
    LengthIsMax25Characters: '長度為25個字以下',
    LengthIsMax10Characters: '長度為10個字以下',
    LengthIsMax20Characters: '長度為20個字以下',
    LengthIsMax11Characters: '長度為11個字以下',
    LengthIsMax50Characters: '長度為50個字以下',
    //商户
    SureToChangeInfoOfTheMerchant: '確定修改該商戶信息嗎?',
    SureToAddThisMerchant: '確定增加該商戶嗎?',
    SureToEnableThisMerchant: '確定啓用該商戶嗎?',
    SureToSuspendThisMerchant: '確定停用該商戶嗎?',
    PhoneNumberAlreadyExists: '手機號碼已存在',
    PhoneNumberAlreadyExists1: '座機已存在',
    OfficePhoneNumberAlreadyExists: '公司號碼已存在',
    TheMerchantIsDisabled: '商戶已停用',
    TheMerchantIsEnabled: '商戶已啟用',
    //店铺
    SureToChangeInfoOfTheShop: '確定修改店鋪信息嗎?',
    SureToSuspendThisShop: '確定停用該店鋪嗎?',
    SureToEnableThisShop: '確定啟用該店鋪嗎?',
    SureToApproveTheShopInfoChange: '確定核準該店鋪的信息修改嗎?',
    SureToRejectTheShopInfoChange: '確定拒絕該店鋪的信息修改嗎?',
    SureToApproveTheAdditonOfTheShop: '確定核準該店鋪的進件申請嗎?',
    SureToRejectTheAdditionOfTheShop: '確定拒絕該店鋪的進件申請嗎?',
    SureToAddThisShop: '確定新增該店鋪嗎?',
    //代理商
    SureToEnableThisAgent: '確定啟用該代理商嗎?',
    SureToSuspendThisAgent: '確定停用該代理商嗎?',
    SureToChangeInfoOfTheSalesman: '確定修改該業務員信息嗎?',
    SureToAddThisAgent: '確定新增該代理商嗎?',
    SureToChangeInfoOfTheAgent: '確定修改該代理商信息嗎?',
    ApproveChangeOfInformation: '確認通過資料修改?',
    ApproveRegistration: '確認通過注冊申請?',
    SureToRejectThisAgentInfoChange: '確定拒絕該代理商的信息修改嗎?',
    SureToRejectTheAdditionOfThisAgent: '確定拒絕該代理商的進件申請嗎?',
    SubmittedApprovalPending: '已提交，審批中',
    TheAgentIsDisabled: '代理已停用',
    TheAgentIsEnabled: '代理已啟用',
    //机构
    SureToAddThisOrganization: '確定新增該機構嗎?',
    SureToChangeInfoOfTheOrganization: '確定修改該機構信息嗎?',
    ThisOrganization: '該機構嗎?',

    MerchantNameAlreadyExists: '商戶名稱已存在',
    AgentNameAlreadyExists: '代理商名稱已存在',
    SubaccountAlreadyExists: '子商戶號已存在',
    // 2.5新增字段
    accountAlreadyExists: '人民幣錢包商戶號已存在',
    HKaccountAlreadyExists: '港幣錢包商戶號已存在',

    PhoneNumberAlreadyExists: '手機號碼已存在',
    ShopNameAlreadyExists: '店鋪名稱已存在',
    CompanyNameAlreadyExists: '公司名稱已存在',
    InstitutionNameAlreadyExists: '機構名稱已存在',
    EmailAlreadyExists: '業務員電郵已存在',
    ContactPersonsEmailAlreadyExists: '聯繫人郵箱地址已存在',

    EmailAlreadyExists: '郵箱地址已存在',

    EmailFormatIncorrect: '郵箱格式不正確,請重新輸入',
    pleaseEnter: '請輸入',
    pleaseInput: '請填寫', // 2.5新增字段
    PleaseAddMerchantOrShopPhoto: "請添加公司或店鋪照片",

    // 2.3新增字段
    // 广告管理
    addImage: '上傳圖片',
    confirmToLaunchThisAdvertisement: '確定發佈該廣告嗎?',
    pleaseInputAdvertisementLink: '廣告圖片路徑',
    paymentPage: '付款成功頁',
    aPPHomePage: 'APP首頁',

    //2.4新增字段
    //公司
    confirmToDisableThisMcompany: '確定停用該公司嗎?',
    confirmToEnableThisMcompany: '確定啟用該公司嗎?',
    confirmToMakeTheChanges: '確定修改該公司信息嗎?',
    TheCompanyIsDisabled: '公司已停用',
    ThecompanyIsEnabled: '公司已啟用',
    SureToAddThisCompany: '確定新增該公司嗎?',
    ApproveChangeOfInformationC: '確認通過資料修改?',
    ApproveRegistrationC: '確認通過注冊申請?',
    SureToRejectThisCompanyInfoChange: '確定拒絕該公司的信息修改嗎?',
    SureToRejectTheAdditionOfThisCompany: '確定拒絕該公司的信息修改嗎?',
    //资金管理
    confirmToWithdraw: '確定兌現HK$ ',
    doubt: '嗎?',
    withdrawAmountShouldBeNoLessThan: '兌現金額不能小于HK$ ',
    // V2.6
    pleaseInputAccountNo: '請輸入商戶號',
    pleaseInputServiceChargeRate: '請填寫微信支付手續費率',
    pleaseSelectServiceChargeBearer: '請選擇手續費承擔方',
    pleaseInputServiceChargeRateHK: '請填寫微信支付HK手續費率',
    pleaseInputServiceChargeRate2: '請填寫支付寶HK手續費率',
    pleaseInputServiceChargeRate3: '請填寫支付寶手續費率',
    alipayAccountAlreadyExists: '支付寶商戶號已存在',
    alipayHKAccountAlreadyExists: '支付寶HK商戶號已存在',

    //2.8
    Confirmthewithdrawalrequestof: '確認',
    hasbeenpaid: '的提現申請已打款?',
    PaymentConfirmation: '確認打款',
    CancelConfirmation: '取消確認',
    Confirmtogiveuptheexport: '確認放棄導出嗎?',

    // 2.10新增字段
    alipayDirectHasAlreadyExist: '支付寶(直連)商戶號已存在',
    WeChatPayHKNoHasAlreadyExist: '微信支付 HK商戶號已存在',
    feeRateFormatIncorrect: '手續費率格式錯誤',
    confirmRefund: '確認退款',
    PleaseInputMerchantName: '請填寫商戶名稱',
    PleaseSelectPassingRules: '請選擇放行規則',

    //V2.12
    notice: '提示：銀聯訂單當天退款只支持全額退款',

    // V2.13
    pleaseInputServiceChargeRate4: '請填寫支付寶(線上)手續費率',
    SubAccountNo5: '支付寶(線上)商戶號',

    // V2.15
    pleaseInputRejectReasons: '請填寫駁回原因',
  },
  login: {
    User: '用户',
    pwd: '密碼',
    Login: '登入',
    PasswordShouldBeAtLeast6Characters: '密碼不可少於6個字符',
  },
  index: {
    UniversalPocketPaymentManagement: '前寶通支付管理',
    Welcome: '歡迎您,',
    Number: '序號',
    Operation: '操作',
    UnipockPaymentSystemAdministration: '前寶通支付管理系統',
    Location: '當前位置',
    Entrance: '歡迎頁',
    Logout: '退出登録',
    MiPay: 'MiPay支付管理系統',
    MerchantOrders: '企業商戶交易報表.xls',
    amendmentApprovalPending: '修改信息審批中',
    newShopApprovalPending: '新增店鋪審批中',
    Salesman: '業務員管理',
    Device: "設備管理",
    searchResults: '搜索結果',
    approval: '審批管理',
    personnel: '人員管理',
    fund: '資金管理',
    name: "名稱",
    name1: "商戶名稱",
    status: '商戶狀態',
    MerchantInfoExcel:'商戶資料',
  },
  //交易流水
  trade: {
    jumped:'交易時段',
    stock:'交易筆數',
    WeChatPay: '微信支付',
    MerchantRef: '交易記錄',
    MerchantRef1: '交易記錄',
    TransactionNo: '交易記錄',
    MerchantRefNo: '商戶編號',
    Agent: '所屬代理商',
    Time: '交易時間',
    PaymentTime: '支付時間',
    originated: '交易金額',
    AmountCNY: '金額(CNY)',
    TransactionType: '交易類型',
    Payment: '付款',
    Refund: '退款',
    PaymentMethod: '支付方式',
    Device: '設備',
    DeviceID: '設備編號',
    Staff: '交易操作員',
    OrderNumber: '訂單號',
    Box: '派派小盒',
    AppPay: 'APP支付',
    MiniProgram: '小程序支付',
    SubordinateMerchant: 'API支付',
    OriginalTransactionNumber: '原系統單號',
    MerchantTransactionNumber: '商戶單號',
    LANDIA8: '聯迪A8',

    // 2.3新增字段
    merchantNumber: '商戶編號',
    fee: '手續費',
    receivableAmount: '實收金額',
    totalAmount: '總交易金額',
    totalFee: '總手續費',
    totalorder:'總交易筆數',
    totalsuccess:'交易成功筆數',
    volume:'總數',
    tabulation :'已添加商戶列表',
    utilization:'交易成功率',
    blanking:'成功交易最大間隔',
    between:'成功交易最小間隔',
    business:'添加統計商戶',
    Remarks: '備註',
    rejectReasons: '駁回原因:',
    transaction: '交易管理',
    frozenAmount: '凍結金額',
    // V2.7新增字段
    TransactionNumber: '原交易單號',
    Refundable: '可退款額',
    RefundAmount: '退款額',
    Amount: '金額',
    PleaseEnterRefundAmount: '請輸入退款金額',
    ExceededMaximum50Refunds: '該比訂單退款已達到 50 次',
    InsufficientBalanceForThisRefund: '帳戶餘額不足以支持退款',
    CannotRefundUnfinishedTransaction: '未完成交易不可退款',
    ExceededRefundablePeriodOf365Days: '退款已超過上限的365天',
    ExceededRefundablePeriodOf540Days: '退款已超過上限的540天',
    ExceededRefundablePeriodOf24Hours: '該筆微信支付退款已超過上限的24小時',
    onlyOfflineBankCardRefundIsSupported: '僅支持綫下銀行卡付款',
    Maximum: '最大值',
    Minimum: '最小值',
    export: '導出',

    // V2.10新增字段
    Unionpay: '銀聯',
    H5Payment: 'H5 支付',
    HideTestMer: '隱藏測試商戶',

    failureReason: '失敗原因',
    userRemarks: '用戶備註',
    merchantRemark: '商戶備註',

    // v2.21新增字段
    transactionDetails:'交易詳情',
    Details:'詳情',
    merInfo:'商戶信息',
    orderInfo:'訂單信息',
    deviceInfo:'設備信息',
    remarksInfo:'備註信息',
    CustomColumns:'自定義列',
    Pay:'支付',
    SerialNumber:'流水號',
    WalletType:'錢包類型',



    // 报关管理
    Administration:'報關管理',
    RecordName:'備案名稱',
    CustomsDeclarationTime:'報關時間',
    CustomsDeclarationNo:'報關編號',
    CustomsDeclarationStatus:'報關狀態',
    customsList:'報關列表',
    CustomsFailureReason:'報關失敗原因'
  },
  //商户
  mer: {
    Registration: '登记',
    Amendment: '修改',
    PendingMerchantApproval: '待審批商戶',
    MerchantAddress: '商戶地址',
    AccountBalance: '帳戶結餘',
    AvailableBalance: '可用結餘',
    OutstandingAmount: '待結算金額',
    ApprovalItem: '審批事項',
    mchtApproval: '商戶審批',
    //商户管理
    Client: "商戶管理",
    //公司资料
    CompanyInfo: '公司資料',
    Merchant: '商戶名稱',
    Merchant1: '商戶名稱',
    BusinessAddress: '業務地址',
    MailAddress: '郵寄地址',
    BRNo: '商業登記號碼',
    Capital: '資本',
    YearsOfBusiness: '成立年數',
    IncorporationCountry: '成立地點',
    EmployeeNo: '僱員人數',
    MerchantType: '商戶類型',
    MerchantCategory: '商戶類目',
    OnlineMerchants: '线上商戶',
    UnderLineMerchant: '线下商戶',
    OwnershipType: '公司類別',
    LimitedCompany: '有限公司',
    Partnership: '合夥',
    SoleProprietor: '獨資',
    Contractperson: '聯絡人 ',
    Contractperson1: '聯絡人 ',
    Email: '電郵地址',
    Position: '職位',
    Position1: '職位',
    OfficePhone: '公司電話',
    Mobile: '手機號碼',
    Fax: '傳真號碼',
    Director: '董事',
    DirectorHKID: '董事身份證號碼',
    DirectorPassport: '董事護照號碼',
    overdue:'公司註冊過期時間',
    Nationality: '國籍',
    //联络资料
    ContactInfo: '聯絡資料',
    URL: '網址',
    TargetLaunchDate: '預定服務推出日期',
    TechnicalContact: '技術聯絡人',
    Email: '電郵',
    PhoneNo: '聯絡電話',
    OperationContact: '營運聯絡人',
    FinanceContact: '財務聯絡人',
    //业务资料
    BusinessInfo: '業務資料',
    BusinessNature: '業務性質',
    ProductsServices: '產品 / 服務類別',
    TargetCustomers: '目標顧客',
    provider: '現在/曾經使用的支付服務',
    Turnover: '過去兩年營業額',
    LastYearSalesVol: '去年度營業額',
    YearBeforeSales: '前年度營業額',
    //互联网上提供的服务
    OnlineBusiness: '網上業務資料',
    DeliveryProvider: '送貨供應商',
    CustomerHotline: '客戶服務熱線',
    ReturnRefundPolicy: '退換貨政策',
    FulfuillmentTime: '收單至送貨需時',
    ReceiptProvided: '有否簽收',
    ForecastMonthlySales: '預算每月營業額',
    After3Months: '三個月後',
    After6Months: '六個月後',
    After1Year: '一年後',
    NoOfTransactions: '每月交易宗數',
    SalesVolume: '每月營業總額',
    AvgTransactionAmount: '每宗交易平均金額',
    MinTransactionAmount: '每宗交易最低金額',
    MaxTransactionAmount: '每宗交易最高金額',
    //结算资讯登记
    SettlementInfo: '清/結算資料',
    AccountName: '帳戶名稱',
    AccountNo: '帳戶號碼',
    BankName: '銀行名稱',
    BankCode: '銀行編號',
    BankCode1: '銀行編號',
    BranchCode: '分行編號',
    Address: '銀行地址',
    SWIFT: '銀行國際代碼',
    ServiceChargeRate: '手續費率',
    ServiceChargeRate1: '微信支付手續費率（%）',
    ServiceChargeRate2: '微信支付MO手續費率（%）',
    ServiceChargeRateHK: '微信支付HK手續費率（%）',
    ServiceChargeBearer: '微信支付手續費承擔方',
    ServiceChargeBearer1: '手續費承擔方',
    Customer: '顧客',
    Consumer: '消費者',
    //附件
    Attachments: '附件',
    BR: '商業登記證',
    CertOfIncoporation: '公司註冊證明',
    DirectorHKID1: '董事身份証或護照',
    BankStatement: '公司銀行月結單',
    Photos: '公司或店鋪照片',
    Logo: '商戶圖標',
    //店铺
    ShopInfo: '店鋪資料',
    ShopModiify: '店铺修改',
    ShortName: '簡稱',
    ShopPhotos: '店鋪相片',
    NewShop: '新店',
    PendingShopApproval: '待審批店鋪',
    Sector: '行業',

    // 2.4新增字段
    company: '公司名稱',
    companyID: '公司編號',
    firm: '公司',

    // V2.7
    WhiteLable: '白標',
    DescriptionOfGoods: "商品名稱",

    // V2.10 银联需求
    UnionpaMerchantNo: '銀聯商戶號',
    UnionpayFeeRate: '銀聯手續費率(%)',
    TerminalNo: '終端號',
    AugsPayUsername: 'AugsPay用戶名',
    NotifyKey: '回調密鈅',
    APIKey: '接口密鈅',
    SignKey: '簽名密鈅',
    AugsPayFeeRate: 'AugsPay手續費率(%)',
    pleaseInputUnionpayFeeRate: '請填寫銀聯手續費率',
    pleaseInputTerminalNo: '請填寫終端號',
    pleaseInputNotifyKey: '請填寫回調密鈅',
    pleaseInputAPIKey: '請填寫接口密鈅',
    pleaseInputSignKey: '請填寫簽名密鈅',
    pleaseInputUnionpayKey: '請填寫銀聯密鈅',
    pleaseInputAugsPayFeeRate: '請填寫AugsPay手續費率',
    UnionpaMerchantNoAlreadyExists: '銀聯商戶號已存在',
    AugsPayUsernameAlreadyExists: 'AugsPay用戶名已存在',
    MopPayUsernameAlreadyExists: 'MopPay用戶名已存在',
    alipayMerchantNo: '支付寶(直連)商戶號',
    alipayFeeRate: '支付寶(直連)手續費率(%)',
    alipayDirect: '支付寶(直連)',
    DirectOnline:'支付寶直連(綫上)',
    DirectOffline:'支付寶直連(綫下)',
    key: '密鈅',
    merchantNo: '商戶號',
    AugsPay: 'AugsPay',
    userName: '用戶名',

    // V2.13
    alipayOnline: '支付寶(線上)',
    alipayOffline: '支付寶(線下)', //v2.14
    ConfirmToReset: '確定重置',
    sPassword: '的密碼嗎?',
    resetPassword: '重置密碼',

    abbreviation: '簡稱',
    merDescription: '商戶簡介',
    tooShort: '商戶簡介過短',
    tooLong: '商戶簡介過長',
    delete: '確定刪除該商戶嗎',
    channelRegistration: '自動進件中',

    //v2.19新增澳门通道字段
    deviceNumber: '設備號',
    shopNumber: '店鋪門牌號',
    // v2.23新增字段
    mcInformationForm:'商戶信息表',
  },
  //代理商
  agent: {
    certificate:"公司註冊文件證明",
    agent: '代理商',
    DirectMerchants: '直營商戶',
    BDStaff: '業務員',
    SubordinateAgents: "下級代理商",
    agentApproval: '代理商審核',
    agentApproval1: '代理商審核',
    //代理商详情 新增 修改
    BasicInfo: '基本資料',
    CompanyInfo: "公司資料",
    Name: '名稱',
    Type: '類型',
    Address: "地址",
    MailAddr: '郵寄地址',
    Contact: '聯絡人',
    PhoneNo: '電話',
    MobileNo: '手機',
    UpperLevelAgent: '上級代理商名稱',
    UpperLevelID: '上級代理編號',
    //结算资料
    SettlementInfo: '結算資料',
    Method: '結算方式',
    Bank: '銀行',
    //佣金资料
    CommissionInfo: '佣金資料',
    Scanner: '掃碼器',
    SubscriptionFee: '加盟費',
    OfflineBase: '線下基率(%)',
    OfflineComm: '線下佣金(%)',
    OnlineBase: '線上基率(%)',
    OnlineComm: '線上佣金(%)',
    EndDate: '終結日期',
    BDStaffNo: '業務員編號',
    commissionRatio: '業務員佣金(%)',
    hintInfo: "基率為手續費不參與分傭計算的部分，其余手續費將按所填寫的傭金比例與代理商進行分傭。例如，某個商戶的手續費率為 1.5%，其代理商的基率為 1%，傭金比例為 50%，那麽（1.5% - 1%）即為參與分傭的手續費率，代理商獲得其中傭金的 50%，即（1.5% - 1%）* 50% = 0.25%，則該代理商可獲得的傭金為其發展的商戶的交易額的 0.25%",

    //V2.15
    POS: 'POS 採購',
    POSmargin: 'POS 按金',
    POSrentalMonth: 'POS 租金/月',
    ScannerPurchase: '掃碼器採購',
    ScannerMargin: '掃碼器按金',
    ScannerRentalMonth: '掃碼器租金/月',
    AlipayCross: '支付寶(跨境錢包)',
    AlipayHK: '支付寶(本地錢包)',

    // v2.20
    WithdrawalRatio:'最低不可提現比例',
  },
  //业务员
  salesman: {
    Salesman: '業務員',
    Name: '姓名',
    ID: '身份證號碼',
    ID1: '身份證號碼',
    OK: '新增',
    Status: '當前狀態',
    NewBDStaff: '新增業務員',
    ModifyTheSalesmanInformation: '修改業務員信息',
    theSalesman: '該業務員嗎?',
    delete: '確定刪除該業務員嗎',
  },
  //机构
  mec: {
    Name1: '機構名稱',
    Status: '機構狀態',
    Contact: '聯繫人名稱',
    Phone: "聯繫人電話",
    Detail: '機構詳情',
    //机构详情
    OrganizationInfo: '機構信息',
    RegisterAddress: '機構註冊地址',
    businessLicenseNo: "營業執照號",
    validityTime: '營業執照有效期',
    LegalPerson: '法人姓名',
    certificateType: '法人證件類型',
    certificateNo: '法人證件號碼',
    PhoneNo: '法人聯繫電話',
    CreationTime: '創建時間',
    CreationTime1: '帳戶建立時間',
    Contact: '聯繫人信息',
    Name: '姓名',
    PhoneNo: '電話',
    PhoneNo1: '電話',
    Email: '電郵',
    //结算信息
    SettlementInfo: '結算信息',
    SettlementBank: '清算銀行名稱',
    City: '銀行所在城市',
    AccountType: '賬戶類型',
    AccountName: '開戶人名稱',
    AccountNo: '結算賬戶號碼',
    PhotoInfo: '照片資料',
    LegalPersonIDFrontPicture: '法人身份證正面照',
    LegalPersonIDReversePicture: '法人身份證反面照',
    LegalPersonBankcardFrontPicture: '法人銀行卡正面照',
    LegalPersonBankcardReversePicture: '法人銀行卡反面照',
    BusinessLicense: '營業執照',
    TaxRegistrationCertificate: '稅務登記證照',
    OrganizationCodeCertificate: '機構代碼證',
    CompanyFrontPicture: '公司正面照',
    CompanyLogo: '公司Logo',
    other: '其他',
  },
  //澳洲商户进件
  AuMer: {
    CompanyInfomation: '公司信息',
    RegistrationName: '公司名稱',
    AustraliaBusinessNumber: '澳洲商業註冊號',
    BusinessInfomation: '業務範圍',
    Website: '公司網站',
    ContactNumber: '公司電話',
    CompanyDescripption: '公司簡介',
    Address: '公司地址',
    City: '城市',
    Postcode: '郵編',
    State: '州',
    ContactInfomation: '聯繫方式',
    FullNmae: '全名',
    JobTitle: '職稱',
    TelephoneNo: '電話號碼',
    EmailAddress: '郵箱地址',
    BillingInfomation: '公司銀行賬戶信息',
    BankName: '銀行名稱',
    CompanyAccountNmae: '賬戶名',
    BSB: '分行代碼',
    AccountNumber: '賬戶',
    Rate: '費率',
    SettlementPeriod: '結算週期',
    OtherInformation: '其他資料',
  },
  //设备管理
  inputBox: {
    merchantName: '商戶名稱',
    exchangeRate: '匯率',
    deviceNum: '設備編號',
    bindingsStartDate: '綁定時間',
    endDateOfBinding: '',
    query: '查詢',
    add: '添加',
    empty: '清空',
    serialNumber: '序號',
    merchantNumber: '商戶編號',
    shopNumber: '店鋪編號',
    shopName: '店鋪名稱',
    deviceState: '設備狀態',
    weChatSonMerchant: '微信子商戶號',
    storageTime: '入庫時間',
    bindingTime: '綁定時間',
    modificationTime: '修改時間',
    operation: '操作',
    modify: '修改',
    cancel: '取消',
    ok: '確定',
    deviceAdd: '設備添加',
    deviceModify: '設備修改',
    newDeviceNumber: '新設備號',
    pleaseEnterTheNewDeviceNumber: '請輸入新設備號',
    pleaseEnterTheStoreNumber: '請輸入店鋪編號',
    pleaseEnterTheDeviceNumber: '請輸入設備編號',
    // 2.5新增字段
    pleaseEnterTheWalletType: '請選擇錢包類別', // 2.6废弃
    pleaseEnterTheChannel: '請選擇通道', // 2.6新增
    success: '成功',
    fail: '失敗',
    modifySuccess: '修改成功',
    addSuccess: '添加成功',
    addFail: '添加失敗',
    queryErr: '查詢條件輸入錯誤或查詢結果不存在',
    //固码
    QRcode: '固碼',
    fixedCodeID: '固碼ID',
    codeNo: '碼號',
    generationDate: '生成日期',
    bindingDate: '綁定日期',
    currentState: '當前狀態',
    paymentChannel: '支付通道',
    channelNumber: '通道編號',
    companyNumber: '公司編號',
    channelState: '通道狀態',
    costRate: '成本費率(%)',
    typeOfTransaction: '交易類型',
    settlementType: '結算類型',
    fixedFee: '固定手續費',
    priorityLevel: '優先級別',
    dateOfEntry: '錄入日期',
    remarks: '備註',
    remarks1: '備註',
    channelRegistrationDate: '通道註冊日期',
    autograph: '簽名',
    adapterOrder: '適配器下單URL',
    paymentAdapter: '適配器代付URL',
    adapterCallback: '適配器回調URL',
    //固碼 輸入框
    startDate: '開始日期',
    endDate: '結束日期',
    unbound: '未綁定',
    bindings: '已綁定',
    disable: '停用',
    enable: '啟用',
    minimumExchangeRate: '最小匯率',
    maximumExchangeRate: '最大匯率',
    receivablesArea: '收款區域',
    Australia: '澳大利亞',
    HongKong: '香港',
    pleaseEnterTheMerchantName: '請輸入商戶名稱',
    chooseBranch: '選擇分店',
    bindingNumber: '綁定數量',
    companySZ: '深圳前寶通信息科技有限公司',
    distributionFixedCode: '分配固碼',
    toTheMerchant: '給商戶',
    toTheAgent: '給代理',
    pleaseEnterTheMerchantName: '請輸入商戶名稱',
    generatingAndBindingSolidCode: '生成並綁定固碼',
    pleaseEnterTheAgentNumber: '請輸入代理商編號',
    generatingFixedCode: '生成固碼',

    // 2.3新增字段
    deviceID: '設備編號',
    deviceType: '設備類型',
    scanner: '掃碼器',
    // QRCode:'固碼',
    deviceStatus: '設備狀態',
    enabled: '已啟用',
    disabled: '已停用',
    merchant: '所屬商戶',
    shop: '所屬店鋪',
    deploymentDate: '投用日期',
    search: '搜索',
    clear: '清空',
    status: '狀態',
    // enable:'啟用',
    // disable:'停用',
    change: '修改',
    cancelBinding: '取消綁定',
    confirmToDisable: '確定停用',
    confirmToEnable: '確定啟用',
    confirmToUnbind: '確定取消綁定',
    confirmToEnableS: '確定啟用',
    confirmToDisableS: '確定停用',
    QRCodeOf: '的固碼?',
    scannerOf: '的掃碼器?',
    pleaseChooseMerchant: '請先選擇所屬商戶',
  },
  // 2.3新增字段
  // 新增设备
  device: {
    newDevice: '新增設備',
    merchant: '所屬商戶',
    shop: '所屬店鋪',
    type: '設備類型',
    scanner: '掃碼器',
    QRCode: '固碼',
    deviceID: '設備編號',
    OK: '確定',
    cancel: '取消',
    deviceNAE: '設備編號已存在',
  },
  // 2.3新增字段
  // 兑现
  newcash: {
    // 兑现审核
    requestDate: '申請時間',
    merchantName: '商戶名稱',
    bankName: '銀行名稱',
    agentName: '代理商名稱',
    bankAccount: '銀行帳戶',
    accountName: '帳戶名稱',
    withdrawAmount: '兌現金額',
    Arrived:"到賬金額",
    withdrawAmount2: '兌現金額',
    withdrawType: '兌現方式',
    withdrawFee: '兌現手續費',
    remitAmount: '轉帳金額',
    status: '狀態',
    pending: '未審核',
    approved: '審核通過',
    rejected: '審核被拒',
    rejected1: '審核駁回',
    paid: '已轉款',
    operation: '操作',
    approve: '通過',
    reject: '拒絕',
    paid: '已轉款',
    confirmToApprove: '確定通過',
    confirmToRefuse: '確定拒絕',
    withdrawRequestFrom: '的兌現申請嗎?',

    // 兑现页
    merchantName: '商戶名稱',
    withdrawStatus: '兌現狀態',
    approvalTime: '審核時間',
    paymentTime: '轉款時間',
    Withdrawal: "兌現",
    Withdrawal1: "財務",
    WithdrawalRecord: "兌現記錄",
    pendingWithdrawalApproval: '兌現審批',

    // 2.4新增字段
    agentOrMerchantName: '代理商/商戶名稱',
    agentOrMerchantID: '代理商/商戶編號',

    // 2.6新增字段
    withdrawErrorTitle: '提示',
    withdrawError: '以下商戶提現失敗，請重試：',
    none: '無',
    withdrawalConfirmation: '提現確認',
  },
  // 2.3新增字段
  // 云账号
  cloudAccount: {
    switchInstitution: '切換機構',
    pleaseSelectInstitution: '請選擇機構',
  },
  // 2.4新增字段
  // 资金管理
  fund: {
    withdrawAmount: '兌現賬戶及金額',
    enterAmount: '輸入金額',
    withdraw: '兌現',
    cheque: '支票付款',
    bankTransfer: '銀行轉賬',
    transferTip: '建設/中銀轉帳免手續費，跨行轉帳每筆HK$ 50',
    withdrawMethod: '兌現方式',
    warning: '溫馨提示',
    warningTitle: '提現時間（按工作日計算）：',
    warningText: '上午9:00前的申請當天出票或轉帳；其後的第二天處理',
    withdrawLimit: '兌現金額不能小於500',
    confirmWithdraw: '確定兌現 ',
    confirmWithdrawSuffix: '嗎?',
    success: '兌現成功',
    failed: '兌現失敗',
    pending: '未審批',
    approved: '審批通過',
    rejected: '審批駁回',
    paid: '已轉款',

    // V2.20
    WithdrawalAmount:'可提現金額',
    warningContent:'可提現金額根據上月退款金額決定，如有疑問請聯系工作人員',
    Withdrawable:"(1)港幣5元每筆匯款 (匯款金額少於或等於港幣500,000元),",
    WithdrawableT:"(2)港幣10元每筆匯款(匯款金額大於港幣500,000元)",

     // v2.22
    see:'查看',
    rechargeRecord:'備用金充值記録',
    refundRecord:'備用金退款記録',
    imprestAudit:'備用金充值審核',
    please:'請',
    confirmRecharge: '確定充值 ',
    reserveMoney:'備用金余額',
    recharge:'充值',
    rechargeTime:'充值時間',
    refundTime:'退款時間',
    rechargeRecords:'充值記錄',
    refundRecords:'退款記錄',
    rechargeAmount:'充值金額',
    refundAmount:'退款金額',
    rechargeNotes:'充值備註',
    rechargeVoucher:'充值憑證',
    fillRemarks:'填寫備註',
    rechargeRechargeInfo:'備用金充值信息',
    reserveWarningTitle:'備用金余額僅用作商戶退款使用,充值後不可提現,如需提現，請聯系工作人員;',
    reserveWarningText:'如需充值備用金，請提前打款並保留打款憑證;',
    reserveWarningContent:'充值金額需與憑證中金額相符,提交充值後將有工作人員審核憑證信息,審核通過方可使用備用金余額進行退款。'
  },
  // 2.4新增字段
  // 分润管理
  profit: {
    profit: '分潤',
    countDate: '結算日期',
    date: '日期',
    acquirerFee: '機構手續費',
    channel: '渠道',
    channelFee: '渠道手續費',
    agentComm: '代理佣金',
    BDComm: '業務員佣金',
    settlement: '結算金額',
    acquirerFeeTotal: '機構總手續費',
    agentCommTotal: '代理佣金總額',
    BDCommTotal: '業務員總佣金',
    wx: '微信',
    payment: '結算收款',
    settlementDateRefund: '結算退款',
  },
  // 2.4新增字段
  // 公司管理
  firm: {
    companyName: '公司名稱',
    companyID: '公司編號',
    agent: '代理名稱',
    companyStatus: '公司狀態',
    establishmentDate: '登記日期',

    // 公司列表
    name: '公司名稱',
    ID: '公司編號',
    status: '狀態',
    merchantQty: '商戶數量',
    registrationDate: '登記日期',
    companyApproval: '公司審批',
  },
  //商户体现
  cash: {
    userNumber: '用戶編號',
    auditStatus: '審批狀態',
    unaudited: '未審批',
    reviewAndPassThrough: '審批通過',
    reviewAndDismissal: '審批駁回',
    alreadyMadeMoney1: '已打款',
    presentType: '提現類型',
    check: '電子支票',
    onlineBanking: '銀行轉賬',
    applicationStartDate: '申請時間',
    applicationEndDate: '',
    userNumber: '用戶編號',
    companyName: '公司名稱',
    applicationTime: '申請時間',
    auditStatus: '審批狀態',
    presentType: '提現類型',
    amountOfCash: '提現金額',
    cankCardNumber: '銀行卡號',
    cardholder: '持卡人',
    bankName: '銀行名稱',
    auditTime: '審批日期',
    remittanceDate: '匯款日期',
    notes: '備注',
    examine: '審批',
    adopt: '通過',
    reject: '駁回',
    playMoney: '打款',
    auditHasPassed: '審批已通過,可打款',
    theAuditHasBeenRejected: '審批已駁回,無法進行操作',
    errOperation: '錯誤操作!已打款',
    alreadyPassed: '審批已通過,不能駁回',
    notRepeatOperation: '審批已駁回,請勿重復操作',
    audit: '審批中',
    notMakeMoney: '審批已駁回,無法打款',
    alreadyMadeMoney: '已打款,請勿重復操作',
    query: '查詢',
    empty: '清空',
  },
  //店铺
  shop: {
    Phone: "聯繫人電話",
    Phone1: "聯繫人電話*",
    Email: '電郵地址',
    Email1: '電郵地址*',
    shopApproval: '店鋪審批',
    shopName: '店鋪名稱',
  },
  // v2.2新增字段
  // 修改密碼
  modifyPwd: {
    PasswordChange: '修改密碼',
    OriginalPassword: '原密碼',
    NewPassword: '新密碼',
    Confirm: '確認密碼',
    OK: '確定',
    Cancel: '取消',
    PasswordIncorrect: '密碼輸入錯誤',
    NewPasswordLessThan6Digits: '新密碼少於6個字符',
    TheTwoPasswordsDoNotMatch: '兩次密碼不一致',
    TheNewPasswordIsTheSameAsTheOldOne: '新密碼與舊密碼相同',
    PleaseInputMoreThan6DigitsPassword: '(請輸入6位以上密碼)',
    PleaseBeTheSameAsOriginalPassword: '(請與新密碼一致)',
    PleaseInputOriginalPassword: '請輸入原密碼',
    PleaseInputPasswordAgain: '請再次輸入密碼',
    PleaseInputPassword: '請輸入密碼',

    formatError: '圖片格式不正確',
  },
  other: {
    PhoneNumberAlreadyExist: '業務員聯絡電話已存在',
    InformationChange: '修改資料',
    ConfirmToMakeTheChanges: '確定修改資料?',
    ConfirmToRegisterTheShop: '確定新增該店鋪?',
    ConfirmToDeleteTheShop: '確定刪除該店鋪?',
    MerchantLogo: '商户標志',
    MerchantInfo: '商戶信息登記表',
    PasswordShouldBeAtLeast6Characters: '密碼不可少於6個字符',
    EmailAlreadyExists: '業務員郵箱已存在',
    EstablishmentFrom: '服務登記時間',
    EstablishmentFrom1: '服務登記',
    EstablishmentFrom2: '帳戶建立時間',
    EstablishmentFrom3: '登記日期',
    EstablishmentTo: '',
  },
  modifyShop: {
    ShopDetail: '店鋪詳情',
    New: '新增',
    Back: '返回',
    Rejected: '審核被拒!',
    ApprovalPending: '審核中...',
    AmendmentApprovalPending: '修改審核中...',
    UploadPhoto: '上傳圖片',
    ShopNumber: '店鋪編號',
    Edit: '修改',
    Suspended: '已停用!',
    ClickToAddPhotos: '點擊添加圖片',
    ShopName: '填寫店名',
    OK: '完成',
    OK1: '提交',
    delete: '刪除店鋪',
  },
  ad: {
    typeOne: '類型一',
    typeTwo: '類型二',
    typeThree: '類型三',
    advertisingPosition: '廣告位',
    resolution: '大小',
    link: '連結',
    adMgmt: '廣告管理',
    adSetup: '廣告編輯',

    // V2.9
    NewAdvertisement: '添加廣告',
    BusinessNature: '廣告行業',
    ConfirmtodeletetheAdvertisement: '確定刪除該條廣告嗎?',
    ConfirmtomodifytheAdvertisement: '確定修改該條廣告嗎?',
    Replacethepicture: '更換圖片',
    Uploadpicture: '上傳圖片',
    AdvertisementName: '廣告名稱',
    Link: '跳轉鏈接',
    PleaseAddAdvertisementPicture: '請添加廣告圖片',

    // V2.14
    adData: '廣告數據',
    Display: '曝光量',
    Click: '點擊量',
    ClickRate: '點擊率',
  },
  // V2.7
  // 商户结算
  settlement: {
    Date: '結算日期',
    Merchant: '商戶名稱',
    MerchantID: '商戶編號',
    SettlementPeriod: '結算週期',
    TransactionAmount: '交易總額',
    Fee: '手續費',
    SettlementAmount: '結算總額',
    Settlement: '商戶結算',
     // v2.23字段
     refundRemarks:'退款備註'
  },
  // 意见管理
  opinion: {
    Date: '日期',
    SuggestionList: '意見列表',
    SuggestionList1: '意見列表',
    SuggestionList2: '意見列表',
    Time: '時間',
    Shop: '店鋪',
    Account: '帳戶',
    AcountName: '帳戶名稱',
    Role: '角色',
    Subject: '主題',
    Content: '內容',
    Suggestion: '意見詳情',
  },
  // 2.10  通知管理
  notify: {
    title: '通告主題',
    content: '',
    content1: '通知內容',
    NotificationHistory: '通告記錄',
    Recipients: '接收人',
    Details: '詳情',
    EditNotification: '通告編輯',
    SelectRecipients: '選擇收件人',
    SendTo: '發送至:',
    Send: '發送',
    All: '全部',
    Agent: '代理商',
    Company: '公司',
    Merchant: '商戶',
    Finance: '財務',
    BD: '業務員',
    AllAgent: '所有代理商',
    AllCompany: '所有公司',
    AllMerchant: '所有商戶',
    AllMerchantAdministrator: '所有商戶管理員',
    AllShop: '所有店鋪',
    AllStaff: '所有員工',
    AllFinance: '所有財務',
    AllBD: '所有業務員',
    Administrator: '管理員',
    MerchantsOf: '直屬商戶',
    ConfirmToSend: '確定發送?',
    Notification: '通告',
    AlreadyExists: '已存在',
    PleaseSelectRecipients: '請選擇收件人',
    Notifications: '消息通告',
    NotificationList: '消息列表',
    NofiticationDetails: '消息詳情',
    contentExceeding: '內容超過2000字符,請刪減內容',
    Only10Images: '每篇通知只允許上傳 10 張圖片',
    pleaceSelectOrEnputMerchantName: '請選擇/輸入商戶名',
    addPicture: '添加圖片',

    // V2.15新增
    Merchant: '商戶',
    Agent: '代理商',
    Company: '公司',
    Shop: '店鋪',
    registrationApproved: '進件審批通過',
    registrationRejected: '進件審批駁回',
    informationModificationApproved: '修改信息審批通過',
    informationModificationRejected: '修改信息審批駁回',
    withdrawalApplicationApproved: '兌現申請審批通過',
    withdrawalApplicationRejected: '兌現申請審批駁回',
    the: '您提交的',
    registrationYouSubmittedHasBeenApproved: '進件申請已通過審批',
    registrationYouSubmittedHasBeenRejectedRejectReason: '進件申請被駁回，駁回原因：',
    informationModificationYouSubmittedHasBeenApproved: '修改信息申請已通過審批',
    informationModificationYouSubmittedHasBeenRejectedRejectReason: '修改信息申請被駁回，駁回原因：',
    theWithdrawalApplicationOf: '您于',
    on: '提交的',
    youSubmittedHasBeenApproved: '兌現申請已通過審批',
    youSubmittedHasBeenRejectedRejectReason: '兌現申請被駁回，駁回原因：',
  },
  // 风控
  risk: {
    report:'交易報告',
    automated:'報告列表',
    should:'報告日期',
    Type: '風控類型',
    Edit: '修改',
    Remove: '移除',
    NewWhiteList: '新增白名單',
    Configuration: '規則設置',
    PassingRules: '放行規則',
    DayAmountLimit: '單日限額',
    HourAmountLimit: '小時限額',
    PerTransactionLimit: '單筆限額',
    MinuteVolumeLimit: '分鐘限量',
    ConfirmWhiteRemoving: '確定從白名單中移除',
    FromWhiteList: '嗎?',
    Abnormalty: '異常交易',
    BlackListed: '轉為黑名單',
    OrderNumber: '訂單號',
    ConfirmGreyRemoving: '確定從灰名單中移除',
    fromGreyList: '嗎?',
    ConfirmMoving: '確定將',
    toBlackList: '轉移到黑名單嗎?',
    GreyListed: '轉為灰名單',
    ConfirmBlackRemoving: '確定從黑名單中移除',
    fromBlackList: '嗎?',
    toGreylist: '轉移到灰名單嗎',
    ConfirmChanging: '確定修改',
    ConfirmChangingRiskControlfactors: '確定修改該行業的風控參數嗎?',
    RiskControl: '风险控制',
    whiteListEdit: '白名單修改',
    whiteList: '白名單',
    greyList: '灰名單',
    blackList: '黑名單',
    items: '筆',
    // v2.23新需求
    riskMerchant:'商戶風控',
    riskTime:'風控時間',
    singleDayLimit:'單日限額',
    singleLimit:'單筆限額',
    addRiskMerchant:'添加風控商戶',
    removeRiskMerchant:'移除風控商戶',
    modifyRiskMerchant:'修改風控商戶',
    isDeleteRiskMerchant:'是否確認從風控列表中移除該商戶？',
    adder:'添加者',
    verifyIsEmpty:'商戶名稱/編號不得為空',
    minLimitRules:'請至少輸入一項限額規則',
    VerifyDcMcName:'該商戶已存在，請重新選擇',
    // v2.32
    TradingLimit:'交易限頻',
    pen:'筆'
  },
  // 审核记录
  History: {
    Applicant: '申請人',
    ApplicantAccount: '申請人帳戶',
    ApprovalHistory: '審核記錄',
    Approver: '審核人',
    ApproverAccount: '審核人帳戶',
    Agent: '代理商',
    Company: '公司',
    Merchant: '商戶',
    shop: '店鋪 ',
    refusalReasons: '駁回原因',
  },
  // V2.12 统计
  count: {
    month: '月',
    week: '周',
    day: '日',
    hour: '時',
    pleaceSelectTime: '請選擇時間',
    endTimeError: '結束時間錯誤',
    pleaseSearchLessThan24Months: '搜索時間請勿超過24個月',
    pleaseSearchLessThan16Weeks: '搜索時間請勿超過16周',
    pleaseSearchSessThan62Days: '搜索時間請勿超過62天',
    pleaseSearchSessThan48Hours: '搜索時間請勿超過48小時',
    todayReceiptAmount: '今日收款總額',
    todayUnionPayAmount:'今日銀聯收款總額',
    todayWeChatAmount:'今日微信收款總額',
    todayHongKongAmount: '今日香港微信總額',
    todayWalletAmount:'今日跨境微信總額',
    todayAlipayAmount:'今日支付寶收款總額',
    todayTransactionVolume: '今日交易量',
    transactionAmount: '交易額',
    transactionVolume: '交易量',
    newMerchant: '新增商戶',
    date: '日期',
    amount: '交易额',
    top10Merchant: 'Top10商戶',
    Month: '月度',
    sinceEstablishment: '開通以來',
    dataSheet: '數據表',
    ranking: '排行',
    failureRate: '失敗率',
  },
  	// V2.20  用户信息
	user:{
		title:'用戶信息',
    tips:'(點擊編輯用戶名和頭像)',
		placeholder:'請輸入（回車確認）',
		qualified1:'請輸入用戶名',
		qualified2:'請正確輸入用戶名',
    qualified3:'用戶名不得含有中英文的特殊字符',
    OK:'確定',
		Cancel:'取消'
	},
  zhTWLocale // 或者用 Object.assign({ message: '妳好' }, zhLocale)
}



// WEBPACK FOOTER //
// ./src/common/lang/zh-tw.js